const Profile=()=>{
    return(
        <div>Prifile</div>
    )
}
export default Profile;